import { render, staticRenderFns } from "./handoutCard.vue?vue&type=template&id=688726d7&scoped=true&"
import script from "./handoutCard.vue?vue&type=script&lang=js&"
export * from "./handoutCard.vue?vue&type=script&lang=js&"
import style0 from "./handoutCard.vue?vue&type=style&index=0&id=688726d7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688726d7",
  null
  
)

export default component.exports